﻿import { useVuelidate } from '@vuelidate/core';
import { required, email } from '@vuelidate/validators';

const contactApp = {
    setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
            fullname: '',
            email: '',
            category: '',
            subject: '',
            remark: ''
        }
    },
    validations() {
        return {
            fullname: { required },
            email: { required, email },
            subject: { required },
            remark: { required }
        }
    },
    methods: {
        async handleSubmit() {
            let isValid = await this.v$.$validate();
            if (isValid) {
                this.$el.submit();
            }
        }
    }
}

export default contactApp;